module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Up_16"],"polygon":[{"$":{"points":"12.76 11.68 8 6.48 3.24 11.68 1.76 10.32 8 3.52 14.24 10.32 12.76 11.68","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Up_16.svg
// module id = tCq4
// module chunks = 1